
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/p/[[...product]]",
      function () {
        return require("private-next-pages/p/[[...product]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/p/[[...product]]"])
      });
    }
  